module.exports = __webpack_public_path__ + "assets/acc654a91d8a078b8b8e6e5612012857.mp4";